import { usePHSPACCResultsTip } from '@components/phs/pacc/results/query/useResults';
import Tooltip from '../../../tooltip';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { AccTaskNameMap } from '@domain/constant/acca/TaskType';
import classNames from 'classnames/bind';
import styles from './testTip.module.scss';

const cx = classNames.bind(styles);

interface TestTipProps {
  sn: number;
  applyResult: PaccApplyResultVO;
}

const TestTip = ({ sn, applyResult }: TestTipProps) => {
  const { data: paccApplyTip } = usePHSPACCResultsTip(sn);

  if (!paccApplyTip) return null;

  const cardList = paccApplyTip.tips?.map((applyTip, index) => {
    const { type, highlightComment, comment } = applyTip;
    return (
      <div key={index} className={cx('card')}>
        <em className={cx('cardTitle')}>{highlightComment}</em>
        <p className={cx('cardDesc')}>{comment}</p>
        <span className={cx('cardTag')}>{AccTaskNameMap[type]}</span>
      </div>
    );
  });

  return (
    <div className={cx('testTipArea')}>
      <strong className={cx('title')}>
        공식개발사가 주는 맞춤형 꿀팁!
        <Tooltip
          type={'competency'}
          content={<p>응시자님이 보완한다면 더 좋을 것 같은 과제들에 대한 응시 팁을 제공해드립니다.</p>}
        />
      </strong>

      <div className={cx('cardArea')}>
        {/* [D] 카드 리스트 영역 */}
        {cardList}

        {/* [D] 할 수 있어요 카드 영역 */}
        <div className={cx('card', 'cheerUp')}>
          <em className={cx('cardTitle')}>
            {applyResult.userName}님도
            <br />할 수 있어요!
          </em>
        </div>
      </div>
    </div>
  );
};

export default TestTip;
